import {Stream2Player} from "./stream2-player";
import {CountDownTimer} from "./countdown-timer";

window.$ = window.jQuery = require('jquery');
import axios from "axios";
import Cookies from "js-cookie";
import Pusher from "pusher-js";

const Stream2Plugin = {};

(function(o) {

    o.isSubscribed = false;
    o.subscribeButtonLink = '#';
    o.oldLoginEmailAddress = '';
    o.oldLoginPassword = '';
    o.oldPasscodenEmailAddress = '';
    o.oldPasscodePassword = '';
    o.oldVerifyEmailAddress = '';
    o.loginEmailValidated = false;
    o.passcodeEmailValidated = false;
    o.sessionVerified = false;
    o.brightcoveVideoId = null;
    o.endpoints = [
        'https://stream2.test/api/brightcove/plugin',
        'https://dev.stream2.app/api/brightcove/plugin',
        'https://stream2.app/api/brightcove/plugin',
        'https://eu.dev.stream2.app/api/brightcove/plugin',
        'https://eu.stream2.app/api/brightcove/plugin',
        'https://ap.dev.stream2.app/api/brightcove/plugin',
        'https://ap.stream2.app/api/brightcove/plugin'
    ];
    o.urls = [
        'https://stream2.test',
        'https://dev.stream2.app',
        'https://stream2.app',
        'https://eu.dev.stream2.app',
        'https://eu.stream2.app',
        'https://ap.dev.stream2.app',
        'https://ap.stream2.app'
    ];
    o.pusher = null;
    o.channel = null;

    o.getParams = function(script_name) {
        var scripts = document.getElementsByTagName("script");
        for(var i=0; i<scripts.length; i++) {
            if(scripts[i].src.indexOf("/" + script_name) > -1) {
                var pa = scripts[i].src.split("?").pop().split("&");
                var p = {};
                for(var j=0; j<pa.length; j++) {
                    var kv = pa[j].split("=");
                    p[kv[0]] = kv[1];
                }
                return p;
            }
        }
        return {};
    }

    o.getUrlParameter = function getParameterByName(name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    o.generateUid = function() {
        return Date.now().toString(36) + Math.random().toString(36).substr(2);
    }

    o.loadScript = function(url) {
        var script = document.createElement('script');
        script.src = url;
        document.head.appendChild(script);
    }

    o.initialize = function () {
        let stream2Params = o.getParams('stream2-plugin.js');

        if(stream2Params)
        {
            window.stream2Params = {
                endpoint: o.endpoints[stream2Params.ep],
                key: stream2Params.k,
                profileId: stream2Params.p
            }
        }


        o.createLoginButton();
        o.injectJavascript();

        if(o.getUrlParameter('tt'))
        {
            o.verifyTempToken().then(response => {
                Cookies.set('S2-SESSION', response.data.data.sessionId);
                Stream2Plugin.isSubscribed = response.data.data.isSubscribed;
                Stream2Plugin.subscribeButtonLink = response.data.data.subscribeButtonLink;
            }).finally(() => {
                o.finalize();
            });
        } else {
            o.finalize();
        }

    }

    o.injectJavascript = function()
    {
        let javascript = axios.post(window.stream2Params.endpoint + '/javascript-dependencies', {
            key: window.stream2Params.key,
            profileId: window.stream2Params.profileId,
            token: o.getUrlParameter('tt'),
            sessionId: Cookies.get('S2-SESSION'),
            tempId: Cookies.get('S2-TEMP-SESSION')
        }).then(response => {
            if(response.data.hasOwnProperty('javascriptUrls')) {
                for (let i = 0; i < response.data.javascriptUrls.length; i++) {
                    o.loadScript(response.data.javascriptUrls[i]);
                }
            }
        }).catch(error => {
            console.log(error);
        });

    }

    o.verifyTempToken = function()
    {
        return axios.post(window.stream2Params.endpoint + '/verify', {
            key: window.stream2Params.key,
            profileId: window.stream2Params.profileId,
            token: o.getUrlParameter('tt'),
            sessionId: Cookies.get('S2-SESSION'),
            tempId: Cookies.get('S2-TEMP-SESSION')
        });
    }

    o.finalize = function()
    {
        o.appendBackdrop();

        o.modal().then(response => {
            if(response.data.success) {
                o.subscribeButtonLink = response.data.data.subscribeButtonLink;
                this.body = $('body');
                this.body.append(response.data.data.html);
                this.body.on('click', '.stream2-auth-btn--login', function (e) {
                    e.preventDefault();
                    $('.stream2-modal__form-message').remove();
                    o.open($('.stream2-modal'));
                });
                this.body.on('click', '.stream2-subscribe-btn', function (e) {
                    e.preventDefault();
                    window.open(Stream2Plugin.subscribeButtonLink, '_blank').focus();
                });
                this.body.on('click', '.stream2-modal__close-btn', function () {
                    o.close($('.stream2-modal'));
                    Stream2Player.close();
                    o.resetModal();
                });
                this.body.on('click', '.stream2-button--panel', function () {
                    o.resetModal();
                    o.showModalContent($($(this).attr('data-panel-target')));
                });
                this.body.on('click', '.stream2-modal', function (e) {
                    if(e.target != this || $(this).find('#stream2-processing-transaction').hasClass('stream2-modal__panel--show')) return;
                    o.close($(this));
                    Stream2Player.close();
                    o.resetModal();
                });
                this.body.on('keypress', '#stream2-auth-login .stream2-form-field__input', function (e) {
                    if(e.which === 13) {
                        $('#stream2-login-button').trigger('click');
                    }
                });
                this.body.on('keypress', '#stream2-auth-passcode .stream2-form-field__input', function (e) {
                    if(e.which === 13) {
                        $('#stream2-validate-passcode-btn').trigger('click');
                    }
                });
                this.body.on('keypress', '#stream2-auth-email-verify .stream2-form-field__input', function (e) {
                    if(e.which === 13) {
                        $('#stream2-send-email-btn').trigger('click');
                    }
                });
                this.body.on('input change', '#stream2-auth-login .stream2-form-field', function () {
                    if(o.hasLoginEmailAddressChanged() || o.hasLoginPasswordChanged()) {
                        o.removeMessage($('#stream2-auth-login'));
                        $('#stream2-auth-login .stream2-form-field').removeClass('stream2-form-field--error');
                    }
                });
                this.body.on('input change', '#stream2-auth-passcode .stream2-form-field', function () {
                    if(o.hasPasscodeEmailAddressChanged() || o.hasPasscodePasswordChanged()) {
                        o.removeMessage($('#stream2-auth-passcode'));
                        $('#stream2-auth-passcode .stream2-form-field').removeClass('stream2-form-field--error');
                    }
                });
                this.body.on('click', '#stream2-validate-passcode-btn', function () {
                    o.handlePasscodeSubmission();
                });
                this.body.on('input change', '#stream2-auth-email-verify .stream2-form-field', function () {
                    if(o.hasVerifyEmailAddressChanged()) {
                        o.removeMessage($('#stream2-auth-email-verify'));
                        $('#stream2-auth-email-verify .stream2-form-field').removeClass('stream2-form-field--error');
                    }
                });
                this.body.on('click', '#stream2-send-email-btn', function () {
                    o.handleVerificationCodeSubmission();
                });
                this.body.on('click', '.stream2-auth-btn', function() {
                });
                this.body.on('click', '.stream2-auth-btn--logout', function(e) {
                    e.preventDefault();
                    Stream2Plugin.showLoginButton();
                    if(Cookies.get('S2-SESSION') && Cookies.get('S2-SESSION') !== 'undefined') {
                        axios.post(window.stream2Params.endpoint + '/logout', {
                            key: window.stream2Params.key,
                            profileId: window.stream2Params.profileId,
                            sessionId: Cookies.get('S2-SESSION')
                        }).then(response => {
                            o.removeSession($('#stream2-auth-login'));
                            Stream2Player.checkIfUserHasAccess(Stream2Player.currentVideoId());
                        }).catch(error => {
                            if(error.response) {
                                Stream2Plugin.showLogoutButton();
                            }
                        });
                    }
                });
                this.body.on('click', '.btn-watch-now-modal', function(e) {
                   e.preventDefault();
                   o.showWatchNowModal();
                });

                o.login();
                o.verifySession($('#stream2-auth-login'), o.loginPopUp);

                this.body.on('keyup', '.stream2-form-field__code-field', function (e) {
                    e.preventDefault();
                    let $verifyButton = $('#stream2-auth-email-verify-code #stream2-verify-code-btn');
                    if(o.checkVerificationCodeInputValue()) {
                        $verifyButton.removeAttr('disabled');
                    } else {
                        $verifyButton.attr('disabled', 'disabled');
                    }
                });

                let ctrlDown = false,
                    ctrlKey = 17,
                    cmdKey = 91,
                    vKey = 86,
                    cKey = 67;

                this.body.on('keyup', function(e) {
                    if (e.keyCode === ctrlKey || e.keyCode === cmdKey) ctrlDown = false;
                })

                this.body.on('paste', '.stream2-form-field__code-field', function (e) {
                    // Get pasted data via clipboard API
                    let clipboardData = e.clipboardData || e.originalEvent.clipboardData || window.clipboardData;
                    let pastedData = clipboardData.getData('Text');
                    pastedData = o.filterCodeInput(pastedData);
                    let $input = $(this);
                    for (let i = 0; i < pastedData.length; i++) {
                        $input.focus();
                        $input.val(pastedData[i]);
                        $input = $input.next('.stream2-form-field__code-field');
                        if(!$input.length) {
                            break;
                        }
                    }
                    e.preventDefault();
                    e.stopPropagation();
                });

                this.body.on('keydown', '.stream2-form-field__code-field', function (e) {
                    if (e.keyCode === ctrlKey || e.keyCode === cmdKey) {
                        ctrlDown = true;
                        return;
                    }
                    if(ctrlDown && (e.keyCode === vKey)) {
                        return;
                    }
                    e.preventDefault();
                    // Is backspace or delete
                    if(e.keyCode === 8 || e.keyCode === 46) {
                        // If already empty
                        if($(this).val('') === null || $(this).val('') === '' || $(this).val('') === undefined) {
                            $(this).prev('.stream2-form-field__code-field').focus();
                            return;
                        }
                        $(this).val('');
                        return;
                    }
                    // If is left arrow
                    if(e.keyCode === 37) {
                        $(this).prev('.stream2-form-field__code-field').focus();
                        return;
                    }
                    // If is right arrow
                    if(e.keyCode === 39) {
                        $(this).next('.stream2-form-field__code-field').focus();
                        return;
                    }
                    let character = String.fromCharCode(e.which);
                    let newInput = o.filterCodeInput(character);
                    if(!/[^a-zA-Z0-9]/g.test(e.key) && e.key.length === 1) {
                        newInput = e.key;
                    }
                    if($(this).val().length < 1 && e.which !== 16) {
                        $(this).val(newInput);
                        $(this).next('.stream2-form-field__code-field').focus();
                    } else {
                        let $nextInput = $(this).next('.stream2-form-field__code-field');
                        if($nextInput.length && ($nextInput.val('') === null || $nextInput.val('') === '' || $nextInput.val('') === undefined)) {
                            $nextInput.trigger('keydown');
                        }
                    }
                });

                this.body.on('click', '#stream2-auth-email-verify-code #stream2-verify-code-btn', function (e) {
                    o.toggleDisableButton($('#stream2-verify-code-btn'));
                    o.showLoading($('#stream2-auth-email-verify-code'));
                    o.checkVerificationCode();
                });

                o.onElementInserted('body', '.stream2-auth-btn', function (params) {
                });

                Stream2Player.checkIfUserHasAccess(Stream2Player.currentVideoId());

            } else if(response.data.data.error) {
                console.error(response.data.data.error);
            } else {
                console.error(response.data);
            }
        });

        o.watchNowModal().then(response => {
            if(response.data.success) {
                this.body = $('body');
                this.body.append(response.data.data.html);

                this.body.on('click', '.btn-watch-now-later', function() {
                    let watchNowId = $(this).attr('data-watch-now-id');

                    $('.btn-watch-now-later').attr('disabled', 'disabled');

                    axios.post(window.stream2Params.endpoint + '/session/videos/watch-now-later', {
                        key: window.stream2Params.key,
                        profileId: window.stream2Params.profileId,
                        sessionId: Cookies.get('S2-SESSION'),
                        tempId: Cookies.get('S2-TEMP-SESSION'),
                        watchNowId: watchNowId,
                    }).then((response) => {
                        window.location.reload(true);
                    }).catch((error) => {
                        window.location.reload(true);
                    });

                });

                this.body.on('click', '.btn-watch-now-later-cancel', function() {
                    o.hideWatchNowModal();
                });
            }
        });

    }

    o.loginPopUp = function() {
        if(o.getUrlParameter('login') && o.sessionVerified === false)
        {
            o.open($('.stream2-modal'));
        }
    }

    o.filterCodeInput = function (input) {
        return input.replace(/[^a-zA-Z0-9]/g,'')
    }

    o.onElementInserted = function (containerSelector, elementSelector, callback) {

        let onMutationsObserved = function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length) {
                    let elements = $(mutation.addedNodes).find(elementSelector);
                    for (let i = 0, len = elements.length; i < len; i++) {
                        callback(elements[i]);
                    }
                }
            });
        };

        let target = $(containerSelector)[0];
        let config = { childList: true, subtree: true };
        let MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
        let observer = new MutationObserver(onMutationsObserved);
        observer.observe(target, config);

    }

    o.setTempId = function() {
        if(o.sessionVerified === false) {
            if(!Cookies.get('S2-TEMP-SESSION') || Cookies.get('S2-TEMP-SESSION') !== 'undefined') {
                Cookies.set('S2-TEMP-SESSION', o.generateUid());
                Stream2Plugin.subscribeButtonLink = Stream2Plugin.subscribeButtonLink.split("?")[0];
                Stream2Plugin.subscribeButtonLink = Stream2Plugin.subscribeButtonLink + '?tid=' + Cookies.get('S2-TEMP-SESSION');
                $('a.stream2-subscribe-btn').attr('href', Stream2Plugin.subscribeButtonLink);
            }
        } else {
            Cookies.remove('S2-TEMP-SESSION');
        }
    }

    o.setupPusher = function () {

        o.pusher = new Pusher(process.env.MIX_PUSHER_APP_KEY, {
            cluster: process.env.MIX_PUSHER_APP_CLUSTER,
        });

        o.channel = o.pusher.subscribe('stream2');

        o.channel.bind('refresh', function(data) {

            if(data.type == 'reload')
            {
                if(data.sessionId == Cookies.get('S2-SESSION'))
                {
                    window.location.reload(true);
                }
            } else if(data.type == 'load') {
                if(data.tempId == Cookies.get('S2-TEMP-SESSION'))
                {
                    Cookies.set('S2-SESSION', data.sessionId);
                    Cookies.remove('S2-TEMP-SESSION');
                    window.location.reload(true);
                }
            }
        });

        o.channel.bind('txnModal', function (data) {
           if(Cookies.get('S2-SESSION'))
           {
               if(Cookies.get('S2-SESSION') == data.sessionId)
               {
                   o.showTransactionProcessing();
               }
           } else {
               if(data.tempId == Cookies.get('S2-TEMP-SESSION'))
               {
                   o.showTransactionProcessing();
               }
           }
        });

        o.channel.bind('txnModalHide', function (data) {

            if(Cookies.get('S2-SESSION'))
           {
               if(Cookies.get('S2-SESSION') == data.sessionId)
               {
                   o.hideTransactionProcessing();
               }
           } else {
               if(data.tempId == Cookies.get('S2-TEMP-SESSION'))
               {
                   o.hideTransactionProcessing();
               }
           }
        });
    }

    o.checkVerificationCode = function () {
        return axios.post(window.stream2Params.endpoint + '/verification-code/validate', {
            key: window.stream2Params.key,
            profileId: window.stream2Params.profileId,
            email: o.oldVerifyEmailAddress,
            verificationCode: o.verificationCodeInputValue(),
            sessionId: Cookies.get('S2-SESSION'),
            tempId: Cookies.get('S2-TEMP-SESSION')
        }).then(response => {
            Stream2Plugin.isSubscribed = response.data.data.isSubscribed;
            Stream2Plugin.subscribeButtonLink = response.data.data.subscribeButtonLink;
            o.handleUserLoggedIn(response);
            $('#stream2-verify-code-btn').removeAttr('disabled');
        }).catch(error => {
            if(error.response) {
                let $panel = $('#stream2-auth-email-verify-code');
                o.removeMessage($panel);
                let errorMessage = error.response.data.error;
                o.showErrorMessage($panel, errorMessage);
                $('#stream2-verify-code-btn').attr('disabled', 'disabled');
            }
        }).finally(() => {
            o.buttonSetup();
            o.hideLoading($('#stream2-auth-email-verify-code'));
        });
    }

    o.createLoginButton = function () {
        let html =
            "<button class=\"stream2-auth-btn stream2-auth-btn--login stream2-sidebar-btn\" data-login=\"Sign In\" data-logout=\"Sign Out\">" +
            "Sign In" +
            "</button>";
        let $button = $(html);
        $('#sidebar .sidebar-content').prepend($button);
    }

    o.showGetAccess = function () {
        o.showModalContent($('#stream2-get-access'));
    }

    o.showLoading = function ($panel) {
        $panel.find('.stream2-modal-loading').fadeIn(200);
    }

    o.hideLoading = function ($panel) {
        $panel.find('.stream2-modal-loading').fadeOut(200);
    }

    o.showLogoutButton = function () {
        $('.stream2-auth-btn.stream2-auth-btn--login').removeClass('stream2-auth-btn--login');
        $('.stream2-auth-btn:not(.stream2-auth-btn--logout)').addClass('stream2-auth-btn--logout');
        $('.stream2-auth-btn').each(function () {
            if($(this).attr('data-logout')) {
                $(this).text($(this).attr('data-logout'));
            }
        });
    }

    o.showLoginButton = function () {
        $('.stream2-auth-btn.stream2-auth-btn--logout').removeClass('stream2-auth-btn--logout');
        $('.stream2-auth-btn:not(.stream2-auth-btn--login)').addClass('stream2-auth-btn--login');
        $('.stream2-auth-btn').each(function () {
            // Add the login text to the login button
            if($(this).attr('data-login')) {
                $(this).text($(this).attr('data-login'));
            }
        });
    }

    o.buttonSetup = function() {
        if(o.sessionVerified) {
            o.showLogoutButton();
        } else {
            o.showLoginButton();
        }
        if(o.shouldShowSubscribeButton()) {
            o.showSubscribeButton();
        } else {
            o.hideSubscribeButton();
        }
    }

    o.verifySession = function($panel, callback = null) {
        if(Cookies.get('S2-SESSION') && Cookies.get('S2-SESSION') !== 'undefined') {
            axios.post(window.stream2Params.endpoint + '/session', {
                key: window.stream2Params.key,
                profileId: window.stream2Params.profileId,
                sessionId: Cookies.get('S2-SESSION'),
                tempId: Cookies.get('S2-TEMP-SESSION')
            }).then(response => {
                window.samlAttributes = {};
                window.samlAttributes.email = response.data.data.email;
                o.sessionVerified = true;
                o.isSubscribed = response.data.data.isSubscribed;
                o.subscribeButtonLink = response.data.data.subscribeButtonLink;
                $('#stream2-auth-login .stream2-form-field').removeClass('stream2-form-field--error');
                o.removeMessage($('#stream2-auth-login'));
                return true;
            }).catch(error => {
                window.samlAttributes = {};
                Cookies.remove('S2-SESSION');
                o.sessionVerified = false;
                o.isSubscribed = false;
                o.removeMessage($panel);
                o.showErrorMessage($panel, "There was an issue logging in.");
                if(error.response.data.error) {
                    console.error(error.response.data.error)
                } else {
                    console.error(error.response)
                }
                return false;
            }).finally(response => {
                o.buttonSetup();
                o.setTempId();
                o.setupPusher();
                if (callback)
                {
                    callback();
                }
                return response;
            })
        } else {
            window.samlAttributes = {};
            o.isSubscribed = false;
            o.sessionVerified = false;
            o.setTempId();
            o.setupPusher();
            o.buttonSetup();
            if (callback)
            {
                callback();
            }
        }
    }

    o.modal = function() {
        return axios.post(window.stream2Params.endpoint + '/modal', {
            key: window.stream2Params.key,
            profileId: window.stream2Params.profileId,
            sessionId: Cookies.get('S2-SESSION'),
            tempId: Cookies.get('S2-TEMP-SESSION')
        });
    }

    o.watchNowModal = function() {
        return axios.post(window.stream2Params.endpoint + '/modal/watch-now-later', {
            key: window.stream2Params.key,
            profileId: window.stream2Params.profileId,
            sessionId: Cookies.get('S2-SESSION'),
            tempId: Cookies.get('S2-TEMP-SESSION')
        });
    }

    o.toggleDisableButton = function(button) {
        if(button.attr('disabled')) {
            button.removeAttr('disabled');
        } else {
            button.attr('disabled', 'disabled');
        }
    }

    o.login = function () {
        this.body.on('click', '#stream2-login-button', function() {
            if(o.isEmpty($('#stream2-login-email').val().trim())) {
                o.removeMessage($('#stream2-auth-login'));
                $('#stream2-auth-login .stream2-form-field').removeClass('stream2-form-field--error');
                o.showErrorMessage($('#stream2-auth-login'), 'You must enter an email address.');
                $('#stream2-auth-login #stream2-login-email').closest('.stream2-form-field').addClass('stream2-form-field--error').focus();
                return;
            }
            if(o.isEmpty($('#stream2-login-password').val().trim())) {
                o.removeMessage($('#stream2-auth-login'));
                $('#stream2-auth-login .stream2-form-field').removeClass('stream2-form-field--error');
                o.showErrorMessage($('#stream2-auth-login'), 'You must enter a password.');
                $('#stream2-auth-login #stream2-login-password').closest('.stream2-form-field').addClass('stream2-form-field--error').focus();
                return;
            }
            if((o.hasLoginEmailAddressChanged() || o.hasLoginPasswordChanged()) && o.isLoginFormSubmittable()) {
                o.oldLoginEmailAddress = $('#stream2-login-email').val().trim();
                o.oldLoginPassword = $('#stream2-login-password').val().trim()
                o.showLoading($('#stream2-auth-login'));
                o.toggleDisableButton($('#stream2-login-button'));
                o.removeMessage($('#stream2-auth-login'));
                axios.post(window.stream2Params.endpoint + '/login', {
                    key: window.stream2Params.key,
                    profileId: window.stream2Params.profileId,
                    email: $('#stream2-login-email').val().trim(),
                    password: $('#stream2-login-password').val().trim(),
                    sessionId: Cookies.get('S2-SESSION'),
                    tempId: Cookies.get('S2-TEMP-SESSION')
                })
                .then(response => {
                    o.handleUserLoggedIn(response);
                }).catch(error => {
                    let errorMessage = 'Oops! Something went wrong.';
                    if (error.response) {
                        Stream2Plugin.showLoginButton();
                        $('.stream2-no-access__button.stream2-auth-btn--login').show();
                        // Request made and server responded
                        if(error.response.data) {
                            if(error.response.data.errors) {
                                for(let key in error.response.data.errors) {
                                    if(Array.isArray(error.response.data.errors[key])) {
                                        if(key === 'email' && error.response.data.errors[key].length) {
                                            $('#stream2-login-email').closest('.stream2-form-field').addClass('stream2-form-field--error');
                                        }
                                        if(key === 'password' && error.response.data.errors[key].length) {
                                            $('#stream2-login-password').closest('.stream2-form-field').addClass('stream2-form-field--error');
                                        }
                                        for (let i = 0; i < error.response.data.errors[key].length; i++) {
                                            errorMessage += error.response.data.errors[key][i] + '<br>';
                                        }
                                    }
                                }
                                o.showErrorMessage($('#stream2-auth-login'), errorMessage);
                            } else if(error.response.status === 401 && error.response.data.error) {
                                $('#stream2-login-email').closest('.stream2-form-field').addClass('stream2-form-field--error');
                                $('#stream2-login-password').closest('.stream2-form-field').addClass('stream2-form-field--error');
                                errorMessage = error.response.data.error;
                                o.showErrorMessage($('#stream2-auth-login'), errorMessage);
                            }
                        }
                    } else if (error.request) {
                        // The request was made but no response was received
                        errorMessage= "Oops! Something when wrong.";
                        console.error(error.request);
                        o.showErrorMessage($('#stream2-auth-login'), errorMessage);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        errorMessage= "Oops! Something when wrong.";
                        console.error(error.message);
                        o.showErrorMessage($('#stream2-auth-login'), errorMessage);
                    }
                }).finally((response) => {
                    o.toggleDisableButton($('#stream2-login-button'));
                    o.hideLoading($('#stream2-auth-login'));
                    if(o.shouldShowSubscribeButton()) {
                        o.showSubscribeButton();
                    } else {
                        o.hideSubscribeButton();
                    }
                });
            } else {
                o.oldLoginEmailAddress = $('#stream2-login-email').val().trim();
                o.oldLoginPassword = $('#stream2-login-password').val().trim()
            }
        });
    }

    o.resetModal = function () {
        $('.stream2-form-field__input').val('');
        $('.stream2-form-field__code-field').val('');
        $('.stream2-modal__panel .stream2-modal__form-message').remove();
        $('.stream2-form-field--error').removeClass('stream2-form-field--error');
        o.oldLoginEmailAddress = '';
        o.oldLoginPassword = '';
        o.oldPasscodenEmailAddress = '';
        o.oldPasscodePassword = '';
        o.oldVerifyEmailAddress = '';
        o.loginEmailValidated = false;
        o.passcodeEmailValidated = false;
    }

    o.handleInvalidCredentials = function ($panel) {
        o.removeSession($panel);
        o.removeMessage($panel);
        o.showErrorMessage($panel, "Invalid credentials.");
        $panel.find('.stream2-form-field').addClass('stream2-form-field--error').focus();
    }

    o.showErrorMessage = function ($panel, message) {
        let $errorMessage = $('<div/>', {
            'class': 'stream2-modal__form-message stream2-modal__form-message--error',
            'html': message
        });
        if($panel.attr('id') === 'stream2-auth-passcode') {
            $errorMessage.css({
                'marginBottom': '0.75em'
            });
        }
        let $fields = $panel.find('.stream2-modal__form .stream2-form-field');
        if(!$fields.length) {
            $fields = $panel.find('.stream2-modal__form .stream2-form-field__code-fields');
        }
        $errorMessage.insertBefore($fields.get(0));
    }

    o.showSuccessMessage = function ($panel, message) {
        let $errorMessage = $('<div/>', {
            'class': 'stream2-modal__form-message stream2-modal__form-message--success',
            'html': message
        });
        $errorMessage.insertBefore($panel.find('.stream2-modal__form .stream2-form-field').get(0));
    }

    o.removeMessage = function ($panel) {
        $panel.find('.stream2-modal__form-message').remove();
    }

    o.removeSession = function($panel) {
        Cookies.remove('S2-SESSION');
        o.verifySession($panel);
    }

    o.close = function ($modal){
        $('body').css({'overflow':''});
        $modal.attr('aria-hidden', true);
        $modal.removeAttr('aria-modal');
        $modal.removeAttr('role');
        o.hideModal();
        o.hideBackdrop();
        $('.stream2-modal__panel').removeClass('stream2-modal__panel--show');
        $('#stream2-auth-login').addClass('stream2-modal__panel--show');
    }

    o.open = function ($modal) {
        $('body').css({'overflow':'hidden'});
        $modal.attr('aria-hidden', true);
        $modal.removeAttr('aria-modal');
        $modal.removeAttr('role');
        o.showBackdrop();
        o.showModal();
    }

    o.showModalContent = function ($newModalPanel) {
        let $oldModalPanel = $('.stream2-modal__panel.stream2-modal__panel--show');
        $oldModalPanel.removeClass('stream2-modal__panel--show');
        $newModalPanel.addClass('stream2-modal__panel--show');
    }

    o.generateAndShowWatchNowModal = function($watchNowId, $watchNowText) {
        $('.watch-now-later-modal-body').html($watchNowText);
        $('.btn-watch-now-later').attr('data-watch-now-id', $watchNowId);
        o.showWatchNowModal();
    }

    o.showWatchNowModal = function() {
        $('.stream2-watch-now-later-modal').addClass('stream2-watch-now-later-modal--show');
        o.showBackdrop();
    }

    o.hideWatchNowModal = function() {
        $('.stream2-watch-now-later-modal').removeClass('stream2-watch-now-later-modal--show');
        o.hideBackdrop();
    }

    o.showModal = function () {
        $('.stream2-modal').addClass('stream2-modal--show');
    }

    o.hideModal = function () {
        $('.stream2-modal').removeClass('stream2-modal--show');
    }

    o.showBackdrop = function () {
        $('.stream2-modal-backdrop').addClass('stream2-modal-backdrop--show');
    }

    o.hideBackdrop = function () {
        $('.stream2-modal-backdrop').removeClass('stream2-modal-backdrop--show');
    }

    o.appendBackdrop = function () {
        $('body').append($('<div/>', {
            'class': 'stream2-modal-backdrop'
        }));
    }

    o.hasLoginEmailAddressChanged = function () {
        return $('#stream2-login-email').val().trim() !== o.oldLoginEmailAddress;
    }

    o.hasLoginPasswordChanged = function () {
        return $('#stream2-login-password').val().trim() !== o.oldLoginPassword;
    }

    o.hasPasscodeEmailAddressChanged = function () {
        return $('#stream2-auth-passcode-email').val().trim() !== o.oldPasscodenEmailAddress;
    }

    o.hasPasscodePasswordChanged = function () {
        return $('#stream2-auth-passcode-passcode').val().trim() !== o.oldPasscodePassword;
    }

    o.hasVerifyEmailAddressChanged = function () {
        return $('#stream2-auth-email-verify-email').val().trim() !== o.oldVerifyEmailAddress;
    }

    o.isLoginFormSubmittable = function () {
        return !o.isEmpty($('#stream2-auth-login #stream2-login-password').val().trim()) && !o.isEmpty($('#stream2-auth-login #stream2-login-email').val().trim());
    }

    o.isPasscodeFormSubmittable = function () {
        return !o.isEmpty($('#stream2-auth-passcode #stream2-auth-passcode-email').val().trim()) && !o.isEmpty($('#stream2-auth-passcode #stream2-auth-passcode-passcode').val().trim());
    }

    o.isVerifyFormSubmittable = function () {
        return !o.isEmpty($('#stream2-auth-email-verify #stream2-auth-email-verify-email').val().trim());
    }

    o.isEmpty = function (value) {
        return o.isEmptyArray(value) || value === '' || value === null || value === undefined || value === 0;
    }

    o.isEmptyArray = function (value) {
        return Array.isArray(value) && (value === undefined || value.length === 0);
    }

    o.handlePasscodeSubmission = function () {
        if(o.isEmpty($('#stream2-auth-passcode-email').val().trim())) {
            o.removeMessage($('#stream2-auth-passcode'));
            $('#stream2-auth-passcode .stream2-form-field').removeClass('stream2-form-field--error');
            $('#stream2-auth-passcode .stream2-form-field:first-child').css({
                'marginTop': '0.5em'
            });
            o.showErrorMessage($('#stream2-auth-passcode'), 'You must enter an email address.');
            $('#stream2-auth-passcode #stream2-auth-passcode-email').closest('.stream2-form-field').addClass('stream2-form-field--error');
            $('#stream2-auth-passcode #stream2-auth-passcode-email').focus();
            return;
        }
        if(o.isEmpty($('#stream2-auth-passcode-passcode').val().trim())) {
            o.removeMessage($('#stream2-auth-passcode'));
            $('#stream2-auth-passcode .stream2-form-field').removeClass('stream2-form-field--error');
            $('#stream2-auth-passcode .stream2-form-field:first-child').css({
                'marginTop': '0.5em'
            });
            o.showErrorMessage($('#stream2-auth-passcode'),'You must enter a password.');
            $('#stream2-auth-passcode #stream2-auth-passcode-passcode').closest('.stream2-form-field').addClass('stream2-form-field--error');
            $('#stream2-auth-passcode #stream2-auth-passcode-passcode').focus();
            return;
        }
        if((o.hasPasscodeEmailAddressChanged() || o.hasPasscodePasswordChanged()) && o.isPasscodeFormSubmittable()) {
            o.oldPasscodeEmailAddress = $('#stream2-auth-passcode-email').val().trim();
            o.oldPasscodePassword = $('#stream2-auth-passcode-passcode').val().trim()
            o.showLoading($('#stream2-auth-passcode'));
            o.toggleDisableButton($('#stream2-validate-passcode-btn'));
            o.removeMessage($('#stream2-auth-passcode'));
            axios.post(window.stream2Params.endpoint + '/login-passcode', {
                key: window.stream2Params.key,
                profileId: window.stream2Params.profileId,
                email: $('#stream2-auth-passcode-email').val().trim(),
                password: $('#stream2-auth-passcode-passcode').val().trim(),
                productId: o.findProductId(),
                sessionId: Cookies.get('S2-SESSION'),
                tempId: Cookies.get('S2-TEMP-SESSION')
            })
            .then(response => {
                Cookies.set('S2-SESSION', response.data.data.sessionId);
                o.verifySession($('#stream2-auth-passcode'));
                o.close($('.stream2-modal'));
                $('#stream2-auth-passcode .stream2-form-field:first-child').css({
                    'marginTop': '0'
                });
                o.resetModal();
            }).catch(error => {
                let errorMessage = 'Oops! Something went wrong.';
                if (error.response) {
                    // Request made and server responded
                    if(error.response.data) {
                        if(error.response.data.errors) {
                            for(let key in error.response.data.errors) {
                                if(Array.isArray(error.response.data.errors[key])) {
                                    if(key === 'email' && error.response.data.errors[key].length) {
                                        $('#stream2-auth-passcode-email').closest('.stream2-form-field').addClass('stream2-form-field--error');
                                    }
                                    if(key === 'password' && error.response.data.errors[key].length) {
                                        $('#stream2-auth-passcode-passcode').closest('.stream2-form-field').addClass('stream2-form-field--error');
                                    }
                                    if(key === 'message' && error.response.data.errors[key].length) {
                                        $('#stream2-auth-passcode-email').closest('.stream2-form-field').addClass('stream2-form-field--error');
                                        $('#stream2-auth-passcode-passcode').closest('.stream2-form-field').addClass('stream2-form-field--error');
                                    }
                                    for (let i = 0; i < error.response.data.errors[key].length; i++) {
                                        errorMessage += error.response.data.errors[key][i] + '<br>';
                                    }
                                }
                            }
                            o.showErrorMessage($('#stream2-auth-passcode'), errorMessage);
                        } else if(error.response.status === 401 && error.response.data.error) {
                            $('#stream2-auth-passcode-email').closest('.stream2-form-field').addClass('stream2-form-field--error');
                            $('#stream2-auth-passcode-passcode').closest('.stream2-form-field').addClass('stream2-form-field--error');
                            errorMessage = error.response.data.error;
                            o.showErrorMessage($('#stream2-auth-passcode'), errorMessage);
                        }
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    errorMessage= "Oops! Something when wrong.";
                    console.error(error.request);
                    o.showErrorMessage($('#stream2-auth-passcode'), errorMessage);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    errorMessage= "Oops! Something when wrong.";
                    console.error(error.message);
                    o.showErrorMessage($('#stream2-auth-passcode'), errorMessage);
                }
            }).finally((response) => {
                o.toggleDisableButton($('#stream2-validate-passcode-btn'));
                o.hideLoading($('#stream2-auth-passcode'));
            });
        } else {
            o.oldPasscodeEmailAddress = $('#stream2-auth-passcode-email').val().trim();
            o.oldPasscodePassword = $('#stream2-auth-passcode-passcode').val().trim()
        }
    }

    o.handleVerificationCodeSubmission = function () {
        if (o.isEmpty($('#stream2-auth-email-verify-email').val().trim())) {
            o.removeMessage($('#stream2-auth-email-verify'));
            $('#stream2-auth-email-verify .stream2-form-field').removeClass('stream2-form-field--error');
            o.showErrorMessage($('#stream2-auth-email-verify'), 'You must enter an email address.');
            $('#stream2-auth-email-verify #stream2-auth-email-verify-email').closest('.stream2-form-field').addClass('stream2-form-field--error');
            $('#stream2-auth-email-verify #stream2-auth-email-verify-email').focus();
            return;
        }
        if (o.hasVerifyEmailAddressChanged() && o.isVerifyFormSubmittable()) {
            o.oldVerifyEmailAddress = $('#stream2-auth-email-verify-email').val().trim();
            o.showLoading($('#stream2-auth-email-verify'));
            o.toggleDisableButton($('#stream2-send-email-btn'));
            o.removeMessage($('#stream2-auth-email-verify'));
            axios.post(window.stream2Params.endpoint + '/verification-code', {
                key: window.stream2Params.key,
                profileId: window.stream2Params.profileId,
                email: $('#stream2-auth-email-verify-email').val().trim(),
                sessionId: Cookies.get('S2-SESSION'),
                tempId: Cookies.get('S2-TEMP-SESSION')
            }).then(response => {
                if(response.data.data && response.data.data.isValidEmail) {
                    o.showModalContent($('#stream2-auth-email-verify-code'));
                    $('.stream2-modal__panel .stream2-modal__form-message').remove();
                    $('#stream2-auth-email-verify-email').val('');
                    return;
                }
                let message = "If we find a matching email address, you will receive a verification code.";
                if(response.data.message) {
                    message = response.data.message;
                }
                o.showSuccessMessage($('#stream2-auth-email-verify'), message);
            }).catch(error => {
                let errorMessage = 'Oops! Something went wrong.';
                if (error.response) {
                    // Request made and server responded
                    if(error.response.data) {
                        if(error.response.data.errors) {
                            for(let key in error.response.data.errors) {
                                if(Array.isArray(error.response.data.errors[key])) {
                                    if(key === 'email' && error.response.data.errors[key].length) {
                                        $('#stream2-auth-email-verify-email').closest('.stream2-form-field').addClass('stream2-form-field--error');
                                    }
                                    for (let i = 0; i < error.response.data.errors[key].length; i++) {
                                        errorMessage += error.response.data.errors[key][i] + '<br>';
                                    }
                                }
                            }
                        } else if(error.response.status === 401 && error.response.data.error) {
                            $('#stream2-auth-email-verify-email').closest('.stream2-form-field').addClass('stream2-form-field--error');
                            errorMessage = error.response.data.error;
                        }
                        o.showErrorMessage($('#stream2-auth-email-verify'), errorMessage);
                    }
                } else if (error.request) {
                    // The request was made but no response was received
                    errorMessage= "Oops! Something when wrong.";
                    console.error(error.request);
                    o.showErrorMessage($('#stream2-auth-email-verify'), errorMessage);
                } else {
                    // Something happened in setting up the request that triggered an Error
                    errorMessage= "Oops! Something when wrong.";
                    console.error(error.message);
                    o.showErrorMessage($('#stream2-auth-email-verify'), errorMessage);
                }
            }).finally((response) => {
                o.toggleDisableButton($('#stream2-send-email-btn'));
                o.hideLoading($('#stream2-auth-email-verify'));
            });
        }
    }

    o.isUserLoggedIn = function () {
        return Cookies.get('S2-SESSION') && Cookies.get('S2-SESSION') !== 'undefined';
    }

    o.isUserSubscribed = function () {
        return Stream2Plugin.isSubscribed;
    }

    o.findProductId = function () {
        // TODO: Update with code to find the product ID
        if($('meta[name="productId"]').length) {
            return $('meta[name="productId"]').attr('content')
        }
        return 1;
    }

    o.verificationCodeInputValue = function () {
        let value = '';
        let $input1 = $('#stream2-code-field-1');
        let $input2 = $('#stream2-code-field-2');
        let $input3 = $('#stream2-code-field-3');
        let $input4 = $('#stream2-code-field-4');
        o.filterCodeInput($input1.val());
        value += $input1.val();
        o.filterCodeInput($input2.val());
        value += $input2.val();
        o.filterCodeInput($input3.val());
        value += $input3.val();
        o.filterCodeInput($input4.val());
        value += $input4.val();
        return value;
    }

    o.checkVerificationCodeInputValue = function ()
    {
        let isValid = true;
        $('.stream2-form-field__code-field').each(function() {
            if($(this).val() === ''){
                isValid = false;
                return false;
            }
        });
        return isValid;
    }

    o.verificationCodeInputPaste = function (element) {
        let values = element.split('');
        $(values).each(function (index) {
            let $inputBox = $('.stream2-form-field__code-field').eq(index);
            $inputBox.val(values[index])
        });
    }

    o.handleUserLoggedIn = function (response) {
        Stream2Plugin.isSubscribed = response.data.data.isSubscribed;
        Stream2Plugin.subscribeButtonLink = response.data.data.subscribeButtonLink;
        o.sessionVerified = true;
        Stream2Plugin.showLogoutButton();
        $('.stream2-no-access__button.stream2-auth-btn--login').hide();
        Cookies.set('S2-SESSION', response.data.data.sessionId);
        o.close($('.stream2-modal'));
        o.resetModal();
        Stream2Player.checkIfUserHasAccess(Stream2Player.currentVideoId());
    }

    o.showTransactionProcessing = function () {
        o.showModalContent($('#stream2-processing-transaction'));
        o.showBackdrop();
        o.showModal();
    }

    o.hideTransactionProcessing = function () {
        o.showModalContent($('#stream2-auth-login'));
        o.hideModal();
        o.hideBackdrop();
    }

    o.shouldShowSubscribeButton = function () {
        return !Stream2Plugin.isUserLoggedIn() || !Stream2Plugin.isUserSubscribed();
    }

    o.showSubscribeButton = function () {
        $('a.stream2-subscribe-btn').attr('href', Stream2Plugin.subscribeButtonLink);
        $('.stream2-subscribe-btn').show();
    }

    o.hideSubscribeButton = function () {
        $('.stream2-subscribe-btn').hide();
    }

})(Stream2Plugin);

export { Stream2Plugin }

Stream2Plugin.initialize();
Stream2Player.initialize();

if(CountDownTimer.hasCountDownTimer()) {
    CountDownTimer.initialize();
}
